'use strict';

import $ from 'jquery';
import './Lib/swipebox.min.js';
import './Lib/jquery.mobilenavigation.js';
import Swiper from 'swiper';
import Maps from './Modules/Maps';
import SpamProtection from './Modules/SpamProtection';

class Site {
    //add some variables here for basic configuration like "stickeHeader: true" and so on
    constructor() {
        this.initGallery();
        this.initForm();
        this.initSlider();
        this.initStickyHeader();
        this.initMobileNavigation();
        this.initGoogleMaps();
        this.initSpamProtection();
    }
    initGallery() {
        $('.js-swipebox').swipebox({
            hideBarsDelay: 0,
        });
    }
    initForm() {
        //outsource to seperate module
        $('.input--with-placeholder .input__field').each(function () {
            if ($(this).val()) {
                $(this).addClass('input__field--not-empty');
            } else {
                $(this).removeClass('input__field--not-empty');
            }
        });

        //set "notEmpty class on blur
        $('.input--with-placeholder .input__field').blur(function () {
            if ($(this).val()) {
                $(this).addClass('input__field--not-empty');
            } else {
                $(this).removeClass('input__field--not-empty');
            }
        });
    }
    initSlider() {
        if ($('.swiper-container').length > 0) {
            var mySwiper = new Swiper('.swiper-container', {
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                speed: 1500,
                effect: 'fade',
                pagination: '.swiper-pagination',
                paginationClickable: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
            });
        }
    }
    initStickyHeader() {
        var header = $('.header');
        var headerHeight = header.height();
        var sidebar = $('.sidebar');

        $(window).on('scroll', function () {
            if ($(window).scrollTop() >= headerHeight) {
                header.addClass('header--sticky');
                sidebar.addClass('sidebar--sticky');
            } else {
                header.removeClass('header--sticky');
                sidebar.removeClass('sidebar--sticky');
            }
        });
    }
    initMobileNavigation() {
        var $nav = $('.nav-list').mobilenavigation({
            breakpoint: 1024,
        });

        $('.header__nav-toggle').click(function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
            $('header').toggleClass('nav--open');
        });
    }
    initGoogleMaps() {
        new Maps();
    }
    initSpamProtection() {
        new SpamProtection();
    }
}

let site = new Site();
